import ClientDocumentsCard from "./client-card-documents";

export default ClientDocumentsCard;